var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 24C18.6165 24 23.9996 18.6168 23.9996 11.9999C23.9996 5.38325 18.6165 0 11.9998 0C5.38314 0 0 5.38325 0 11.9999C0 18.6168 5.38314 24 11.9998 24ZM11.9998 1.6427C17.7107 1.6427 22.3569 6.28892 22.357 11.9999C22.357 17.711 17.7109 22.3572 11.9998 22.3573C6.28892 22.3572 1.64281 17.711 1.64281 11.9998C1.64281 6.28903 6.28892 1.6427 11.9998 1.6427Z",
    fill: "#15243E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3882 17.1395C10.709 17.4602 11.2291 17.4601 11.5497 17.1395C11.8706 16.8187 11.8706 16.2987 11.5496 15.9778L8.39342 12.8218L17.5331 12.8209C17.9867 12.8208 18.3543 12.4531 18.3543 11.9993C18.3542 11.5457 17.9866 11.1782 17.533 11.1782L8.39298 11.1791L11.5499 8.02233C11.8707 7.70156 11.8707 7.18137 11.5499 6.86072C11.3895 6.70039 11.1793 6.62012 10.9691 6.62012C10.7589 6.62012 10.5488 6.70039 10.3883 6.86061L5.82938 11.4194C5.67529 11.5734 5.58878 11.7823 5.58878 12.0002C5.58889 12.2181 5.6754 12.4269 5.82949 12.5812L10.3882 17.1395Z",
    fill: "#15243E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.f32250c847642fe7b574af1f1e3b599e.svg";
export { ForwardRef as ReactComponent };